// src/utils/groqService.js

/**
 * Simple GROQ lookup helper
 * Uses environment variables:
 * - REACT_APP_GROQ_PROJECT_ID
 * - REACT_APP_GROQ_DATASET
 * - REACT_APP_GROQ_TOKEN
 *
 * The function attempts to find a document of type `explanation` that matches the
 * question text and returns the `explanation` field if found.
 */
export async function fetchExplanationFromGROQ(questionText) {
  const projectId = process.env.REACT_APP_GROQ_PROJECT_ID;
  const dataset = process.env.REACT_APP_GROQ_DATASET || "production";
  const token = process.env.REACT_APP_GROQ_TOKEN;

  if (!projectId || !dataset || !token) return null;

  // Escape double quotes to avoid breaking the GROQ expression
  const safeQ = String(questionText || "").replace(/"/g, '\\"');

  // Simple GROQ query - adjust `_type` and field names to match your dataset
  const groq = `*[_type == "explanation" && question match "${safeQ}"][0]{explanation}`;
  const url = `https://${projectId}.api.sanity.io/v1/data/query/${dataset}?query=${encodeURIComponent(
    groq
  )}`;

  try {
    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      console.warn("GROQ request failed", res.status);
      return null;
    }

    const json = await res.json();
    // Sanity returns `{ result: { explanation: '...' } }` for this query
    return json?.result?.explanation || null;
  } catch (err) {
    console.error("Error querying GROQ:", err);
    return null;
  }
}
